// textContent.js
const fullText = `
 It was cold and there was snow on the ground and he rode past me and kept on goin'. Never said nothin'. He just rode on past and he had this blanket wrapped around him and he had his head down and when he rode past I seen he was carryin' fire in a horn the way people used to do and I could see the horn from the light inside of it. About the color of the moon. And in the dream I knew that he was goin' on ahead and he was fixin' to make a fire somewhere out there in all that dark and all that cold and I knew that whenever I got there he would be there. And then I woke up.
`;


// const words = fullText.split(/[\s,.;!?]+/)
// console.log(words.length);

export default fullText;